import React from 'react'
import ENV from '../../env'

const FooterColumnContent = props => {
  return (
    <div>
      <div className={`footer-content-wrapper ${props.isHidden ? 'd-none d-xl-block' : ''}`}>
        {
          props.rows.map( (row, index) => {
            return <div className="footer-content" key={index}>
              <a href={ENV.root_path + row.url}>{row.title}</a>
            </div>
          })
        }
      </div>
      <div className="footer-border"> </div>
    </div>
  )
}

export default FooterColumnContent
